export default {
  // Destinations
  home: 'Home',
  notifications: 'Notifications',
  search: 'Search',
  drive: 'Drive',
  files: 'Files',
  documents: 'Documents',
  email: 'Email',
  chat: 'Chat',
  channels: 'Channels',
  tasks: 'Tasks',
  calendar: 'Calendar',
  agents: 'Agents',
  customers: 'Customers',
  calls: 'Calls',
  reviews: 'Reviews',
  scheduling: 'Scheduling',
  external: 'External',
  activity: 'Activity',
  recent: 'Recent',
  settings: 'Settings',

  // Go-to shortcuts
  goTo: 'Go to {{label}}',
  goToPage: 'Go to page',
  sendInvites: 'Send Invites',

  // Open-in-split menu
  openInNewSplit: 'Open in new split',
  openFullscreen: 'Open fullscreen',
  openInCurrentSplit: 'Open in current split',
  contentAlreadyOpen: 'Content already open',

  // Rail buttons
  hideFromSidebar: 'Hide from sidebar',
  unreadItems: 'Unread items',
  activeCall: 'Active call',
  returnToCall: 'Return to call',
  nextMeeting: 'Next meeting: {{time}}',
  more: 'More',
  moreOptions: 'More options',
  create: 'Create',
  getMobileApp: 'Get the mobile app',
  signedInAs: 'Signed in as {{name}}',
  commandMenu: 'Command Menu',
  searchEverything: 'Search everything',

  // Customize sidebar
  customizeSidebar: 'Customize sidebar',
  customizeSidebarDescription:
    'Choose which apps appear in the sidebar and drag to reorder them. Home always stays first.',
  moveItemUp: 'Move {{label}} up',
  moveItemDown: 'Move {{label}} down',
  dragToReorder: 'Drag to reorder',
  reorderItem: 'Reorder {{label}}',

  // App update
  updateAvailable: 'Update available',
  updateNewVersionTitle: 'New version available',
  updateWebDescription:
    'A new version of Macro is ready. Reload the page to use it.',
  updateWebFailedLoadDescription:
    "Part of Macro couldn't load because a new version is out. Reload the page to use it.",
  updateReload: 'Reload',
  updateReadyTitle: 'Update ready',
  updateBundleDescription:
    'A new version of the Macro desktop app has downloaded. Update to start using it.',
  updateAction: 'Update',
  updateDesktopReadyTitle: 'Desktop app update ready',
  updateNativeDescription:
    'Restart Macro to install it, or keep working and it installs when you quit.',
  updateRestartAndUpdate: 'Restart and update',
  updateNativePreparingDescription:
    'Saving your work before Macro restarts to install the update.',
  updatePreparingRestart: 'Preparing to restart…',
};
